<template>
  <svg class="exhibition-feature-icon" viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <g v-if="feature === 'hall-across'">
      <path d="M5 11 23 6l12 5v23l-12-5-18 5V11ZM23 6v23" />
      <path d="m10 14 8-2v11l-8 2V14Zm17-1 5 2v15" opacity=".55" />
    </g>
    <g v-else-if="feature === 'building'">
      <path d="m4 15 16-8 16 8-16 8-16-8Z" />
      <path d="M7 17v13l13 6 13-6V17M20 23v13" opacity=".6" />
      <path d="m14 15 6-3 6 3-6 3-6-3ZM11 19v9m18-9v9" />
      <path d="m3 32 17 8 17-8" opacity=".35" transform="translate(0 -1)" />
    </g>
    <g v-else-if="feature === 'orientation'">
      <path d="M5 7h30v23H5V7ZM16 30v5m8-5v5M12 35h16" />
      <path d="M10 12h10v5h-4v8h-6V12Z" opacity=".65" />
      <path d="M25 13h5m-5 5h5m-5 5h3" opacity=".45" />
      <circle cx="13" cy="21" r="1.3" fill="currentColor" stroke="none" />
    </g>
    <g v-else-if="feature === 'light-dark'">
      <path d="M20 5v30M5 8h10M5 32h10M25 8h10v24H25" opacity=".45" />
      <circle cx="10" cy="20" r="3.5" />
      <path d="M10 13v1m0 12v1M3 20h1m12 0h1m-12-5 1 1m8 8 1 1m-10 0 1-1m8-8 1-1M33 23a6 6 0 0 1-7-8 6 6 0 1 0 7 8Z" />
    </g>
    <g v-else-if="feature === 'afterword'">
      <path d="M5 7h19v18H5V7ZM9 12h11M9 16h11M9 20h7" />
      <path d="M13 29c5-2 8-2 12 0 4-2 7-2 11 0v8c-4-2-7-2-11 0-4-2-7-2-12 0v-8ZM25 29v8" />
    </g>
    <g v-else-if="feature === 'arrival'">
      <path d="M7 33V7h26v26M14 33V13h12v20" />
      <path d="M14 13l8 3v17h-8M25 33h10M5 33h5" />
      <path d="M18.5 23v3" />
      <path d="M8 3h24" opacity=".35" />
    </g>
    <g v-else-if="feature === 'walls'">
      <path d="M6 33V7h28v26H6Z" opacity=".4" />
      <path d="M12 14h12M12 20h16M12 24h16M12 28h10" />
      <path d="M12 10h3" opacity=".5" />
    </g>
    <g v-else-if="feature === 'objects'">
      <circle cx="20" cy="15" r="10" />
      <ellipse cx="20" cy="15" rx="4.5" ry="10" opacity=".6" />
      <path d="M10 15h20M20 25v6M13 31h14l4 4H9l4-4Z" />
      <path d="M9 35v2h22v-2" opacity=".4" />
    </g>
    <g v-else-if="feature === 'rooms'">
      <path d="M16 17H6V6h11v7M23 13V6h11v11H20M14 23H6v11h11V20M23 23h11v11H23V23Z" />
      <path d="M17 10h6M10 17v6M17 28h6" opacity=".5" />
      <circle cx="11.5" cy="11.5" r="1" fill="currentColor" stroke="none" />
      <circle cx="28.5" cy="11.5" r="1" fill="currentColor" stroke="none" />
      <circle cx="28.5" cy="28.5" r="1" fill="currentColor" stroke="none" />
    </g>
    <g v-else-if="feature === 'lighting'">
      <path d="M20 4v6M15 10h10l2 5H13l2-5Z" />
      <path d="M14 19 7 31M26 19l7 12M20 20v7" opacity=".55" />
      <ellipse cx="20" cy="32" rx="13" ry="3" />
    </g>
    <g v-else-if="feature === 'audio'">
      <path d="M7 26V18a13 13 0 0 1 26 0v8" />
      <path d="M7 20h3v11H7a3 3 0 0 1-3-3v-5a3 3 0 0 1 3-3ZM33 20h-3v11h3a3 3 0 0 0 3-3v-5a3 3 0 0 0-3-3Z" />
      <path d="M16 21v6M20 17v14M24 21v6" opacity=".65" />
    </g>
    <g v-else-if="feature === 'language'">
      <path d="M23 13V6H5v22h10M17 12h18v22H17V12Z" />
      <path d="m9 21 4-10 3 7M10.5 18h5" opacity=".6" />
      <path d="M21 20h10M26 16v4M23 20c1 6 4 8 8 9M29 20c-1 6-4 8-8 9" />
    </g>
  </svg>
</template>

<script>
export default {
  props: { feature: { type: String, required: true } },
};
</script>
